module.exports = __webpack_public_path__ + "img/V-R-1-unload-connect.0e5114ce.png";